export default __webpack_public_path__ + "static/media/grad_photo.9ad1392e.png";